function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ImagesGrid from "segments/desktop/core-components/images-grid/images-grid";
import { StyledImageWithParagraphGridComponent } from "./image-with-paragraph-grid-component.scss";
import DefaultProps from "./default-props";
class ImageWithParagraphGridComponent extends PureComponent {
    render() {
        const _this_props = this.props, { images, imagePosition, textAlign, titleSize, textSize, autoHeight } = _this_props, rest = _object_without_properties(_this_props, [
            "images",
            "imagePosition",
            "textAlign",
            "titleSize",
            "textSize",
            "autoHeight"
        ]);
        return /*#__PURE__*/ _jsx(StyledImageWithParagraphGridComponent, {
            className: "image-with-paragraph-grid-component",
            children: /*#__PURE__*/ _jsx(ImagesGrid, _object_spread({
                images: images,
                isWithParagraph: true,
                imagePosition: imagePosition,
                textAlign: textAlign,
                titleSize: titleSize,
                textSize: textSize,
                fitHeightToImgHeight: autoHeight
            }, rest))
        });
    }
}
export { ImageWithParagraphGridComponent as default };
ImageWithParagraphGridComponent.defaultProps = DefaultProps;
